import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { EditIcon } from "../../../ui/icons/edit";
import { TrashIcon } from "../../../ui/icons/trash";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { formatterDate, optionsFormatter, OptionType } from "../../../utils";
import { GetAllOdc, resetGetAllOdcStatus } from "../../odc/slice";
import { GetByIdPersonalManagement, resetGetByIdPersonalManagementResourcesStatus } from "../slice";
import { CDXM026PopupAdd } from "./boxPopupOptions/add";
import { CDXM026PopupEdit } from "./boxPopupOptions/edit";
import { CDXM026DTOResponse } from "./dataService/dto";
import { addCDXM026Instance, CDXM026Delete, GetCDXM026ById, resetCDXM026CreationRequest, resetCDXM026DeleteStatus, resetCDXM026Errors, resetCDXM026Instances, resetCDXM026UpdateRequest, resetGetCDXM026ByIdStatus, setCDXCompanyName, setCDXIdToUpdate, setPMId, setUpdateCDXActive, setUpdateCDXClient, setUpdateCDXClientRelationshipType, setUpdateCDXEndingDate, setUpdateCDXNote, setUpdateCDXOperator, setUpdateCDXOperatorRelationshipType, setUpdateCDXProtocolIdEntry, setUpdateCDXStartingDate, setUpdateCDXSupervisory } from "./slice";

export function BoxCDXM026() {
    const dispatch = useAppDispatch()
    const CDXM026State = useAppSelector(state => state.PMCDXM026)
    const odcState = useAppSelector(state => state.odc)
    const PMState = useAppSelector(state => state.personalManagement)
    const [openPopup, setOpenPopup] = useState<boolean>(false)
    const [openPopupEdit, setOpenPopupEdit] = useState<boolean>(false)
    const [odc, setOdc] = useState<OptionType[]>([])

    const onEditHandler = (CDX: CDXM026DTOResponse) => {
        if (CDX.client !== null && CDX.clientRelationshipType !== null) {
            dispatch(setCDXCompanyName(CDX.customerCompanyName))
            dispatch(setUpdateCDXClient(CDX.client!))
            dispatch(setUpdateCDXClientRelationshipType(CDX.clientRelationshipType))
        } else if (CDX.operator !== null && CDX.operatorRelationshipType !== null && CDX.odcId !== null) {
            dispatch(setUpdateCDXOperator(CDX.operator))
            dispatch(setUpdateCDXOperatorRelationshipType(CDX.operatorRelationshipType))
            dispatch(setUpdateCDXSupervisory(CDX.odcId))
        }
        dispatch(setUpdateCDXActive(CDX.active))
        dispatch(setUpdateCDXEndingDate(CDX.ending))
        dispatch(setUpdateCDXNote(CDX.note))
        dispatch(setUpdateCDXStartingDate(CDX.starting))
        dispatch(setUpdateCDXProtocolIdEntry(CDX.protocolIdEntry !== undefined ? String(CDX.protocolIdEntry) : undefined))
        dispatch(setCDXIdToUpdate(CDX.id))
        setOpenPopupEdit(true)
    }

    useEffect(() => {
        dispatch(GetAllOdc({ itemsPerPage: 0, page: 0 }))
    }, [])

    useEffect(() => {
        if (odcState.getAllOdcStatus === 'successfully' && odcState.getAllOdcResponse !== undefined) {
            dispatch(resetGetAllOdcStatus())
            const data = odcState.getAllOdcResponse.data.map(odc => ({
                value: odc.id,
                label: odc.companyName,
            } as OptionType))
            setOdc(data)
        }
    }, [odcState.getAllOdcStatus])

    useEffect(() => {
        if (PMState.currentPersonalManagementId) {
            dispatch(setPMId(PMState.currentPersonalManagementId))
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
        }
    }, [PMState.currentPersonalManagementId])

    useEffect(() => {
        dispatch(resetCDXM026Instances())
        if (
            PMState.getByIdPersonalManagementResourcesStatus === 'successfully' &&
            PMState.getByIdPersonalManagementResourcesResponse?.m026Ids
        ) {
            dispatch(resetGetByIdPersonalManagementResourcesStatus('idle'))
            for (let index = 0; index < PMState.getByIdPersonalManagementResourcesResponse.m026Ids.length; index++) {
                dispatch(GetCDXM026ById(PMState.getByIdPersonalManagementResourcesResponse.m026Ids[index].toString()))
            }
        }
    }, [PMState.getByIdPersonalManagementResourcesStatus])

    useEffect(() => {
        if (CDXM026State.getCDXM026ByIdStatus === 'successfully' && CDXM026State.getCDXM026ByIdResponse !== undefined) {
            dispatch(addCDXM026Instance(CDXM026State.getCDXM026ByIdResponse))
            dispatch(resetGetCDXM026ByIdStatus())
        }
    }, [CDXM026State.getCDXM026ByIdStatus])

    useEffect(() => {
        if (CDXM026State.CDXM026DeleteStatus === 'successfully') {
            dispatch(resetCDXM026DeleteStatus())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
        }
    }, [CDXM026State.CDXM026DeleteStatus])

    return (
        <div className="p-6">
            <div className="space-y-3">
                <div className="flex items-center justify-between">
                    <span className="font-bold text-2xl text-neutral-850">CDX M026</span>
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi CDX M026"
                        onClick={() => setOpenPopup(true)}
                    />
                </div>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-text-md min-w-[1200px]">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Cliente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. Op.</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Ingresso</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Uscita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipologia Rapporto</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Inizio</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Fine</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo M026</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">ODC</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[72px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {CDXM026State.CDXInstances.length === 0 ? (
                                <tr>
                                    <td colSpan={12} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                        Nessun record CDX M026 trovato
                                    </td>
                                </tr>
                            ) : (
                                CDXM026State.CDXInstances.map((CDX, index) => (
                                    <tr
                                        key={CDX.id}
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {CDX.customerCompanyName || CDX.operator}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {CDX.countryRegion}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {CDX.clientCode}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(CDX.startingDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(CDX.endingDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {CDX.clientRelationshipType || CDX.operatorRelationshipType}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(CDX.starting)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(CDX.ending!)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {CDX.protocolEntryInfo}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700">
                                            {CDX.note}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {optionsFormatter(CDX.odcId!, odc)}
                                        </td>
                                        <td className="px-3 py-2 w-[72px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => onEditHandler(CDX)}
                                                >
                                                    <EditIcon color={"Orange"} size={18} />
                                                </button>
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => dispatch(CDXM026Delete(CDX.id!))}
                                                >
                                                    <TrashIcon color={"Orange"} size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {openPopup && (
                <PopupForm title="Aggiungi CDX M026" close={() => {
                    dispatch(resetCDXM026CreationRequest())
                    dispatch(resetCDXM026Errors())
                    setOpenPopup(false)
                }}>
                    <CDXM026PopupAdd close={() => setOpenPopup(false)} />
                </PopupForm>
            )}

            {openPopupEdit && (
                <PopupForm title="Modifica CDX M026" close={() => {
                    dispatch(resetCDXM026UpdateRequest())
                    dispatch(resetCDXM026Errors())
                    setOpenPopupEdit(false)
                }}>
                    <CDXM026PopupEdit close={() => setOpenPopupEdit(false)} />
                </PopupForm>
            )}
        </div>
    )
}